import RemovedRightSideUnitComponent from "@inter-ikea-storagetwo/range/dist/components/RemovedRightSideUnitComponent";
const handleables = [RemovedRightSideUnitComponent.componentSerializationKey];
export default class PlannerComponentSerializer {
    constructor() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    canHandle(serializationKey) {
        return handleables.some((componentName) => componentName.includes(serializationKey));
    }
    deserialize(serializationKey, json) {
        const data = JSON.parse(json.toString());
        switch (serializationKey) {
            case RemovedRightSideUnitComponent.componentSerializationKey:
                return new RemovedRightSideUnitComponent(data.sideUnitRef);
        }
        return null;
    }
}
